import React, { Component } from 'react';
import '../App.css';

class TitleScreen extends Component {

constructor() {
	super();
	this.state = {};
}

componentDidMount() {

  let introButton = document.getElementById('introButton');

  setTimeout(()=>{introButton.style.display="initial";}, 4000);

  setTimeout(()=>{introButton.style.opacity=1;}, 4000);

  setTimeout(()=>{introButton.classList.add('pulse');}, 6000);
}

componentWillUnmount() {
	document.getElementById('titleScreen').style.transform='rotateY(90deg)';
}

  render() {
    return (
      <div id="titleScreen" >
        <button className='pulse introButton' id='introButton' onClick={this.props.nextStage}>Play</button>
      </div>
    );
  }
}

export default TitleScreen;



// WEBPACK FOOTER //
// ./src/components/TitleScreen.js